/**
 * useDashboard — TanStack Query hooks for the dashboard page.
 */

import { useQuery } from '@tanstack/react-query';
import { getRecentAuditLogs } from '@/services/dashboardService';

// ─── Query keys ────────────────────────────────────────────────────────────────

export const dashboardKeys = {
  activity: (n: number) => ['dashboard', 'activity', n] as const,
};

// ─── Recent audit activity ─────────────────────────────────────────────────────

export function useRecentActivity(count = 12) {
  return useQuery({
    queryKey: dashboardKeys.activity(count),
    queryFn:  () => getRecentAuditLogs(count),
    staleTime: 60 * 1000, // 1 min
  });
}
